import e from '../../../d3-scale-chromatic/src/categorical/category10.js';
import r from '../../../d3-scale-chromatic/src/categorical/Accent.js';
import n from '../../../d3-scale-chromatic/src/categorical/Dark2.js';
import t from '../../../d3-scale-chromatic/src/categorical/Paired.js';
import o from '../../../d3-scale-chromatic/src/categorical/Pastel1.js';
import i from '../../../d3-scale-chromatic/src/categorical/Pastel2.js';
import u from '../../../d3-scale-chromatic/src/categorical/Set1.js';
import a from '../../../d3-scale-chromatic/src/categorical/Set2.js';
import l from '../../../d3-scale-chromatic/src/categorical/Set3.js';
import '../../../d3-scale-chromatic/src/categorical/Tableau10.js';
import b, { scheme } from '../../../d3-scale-chromatic/src/diverging/BrBG.js';
import v, { scheme as scheme$1 } from '../../../d3-scale-chromatic/src/diverging/PRGn.js';
import _, { scheme as scheme$2 } from '../../../d3-scale-chromatic/src/diverging/PiYG.js';
import w, { scheme as scheme$3 } from '../../../d3-scale-chromatic/src/diverging/PuOr.js';
import O, { scheme as scheme$4 } from '../../../d3-scale-chromatic/src/diverging/RdBu.js';
import k, { scheme as scheme$5 } from '../../../d3-scale-chromatic/src/diverging/RdGy.js';
import j, { scheme as scheme$6 } from '../../../d3-scale-chromatic/src/diverging/RdYlBu.js';
import z, { scheme as scheme$7 } from '../../../d3-scale-chromatic/src/diverging/RdYlGn.js';
import A, { scheme as scheme$8 } from '../../../d3-scale-chromatic/src/diverging/Spectral.js';
import ue, { scheme as scheme$f } from '../../../d3-scale-chromatic/src/sequential-multi/BuGn.js';
import ae, { scheme as scheme$g } from '../../../d3-scale-chromatic/src/sequential-multi/BuPu.js';
import le, { scheme as scheme$h } from '../../../d3-scale-chromatic/src/sequential-multi/GnBu.js';
import se, { scheme as scheme$i } from '../../../d3-scale-chromatic/src/sequential-multi/OrRd.js';
import ce, { scheme as scheme$j } from '../../../d3-scale-chromatic/src/sequential-multi/PuBuGn.js';
import fe, { scheme as scheme$k } from '../../../d3-scale-chromatic/src/sequential-multi/PuBu.js';
import pe, { scheme as scheme$l } from '../../../d3-scale-chromatic/src/sequential-multi/PuRd.js';
import de, { scheme as scheme$m } from '../../../d3-scale-chromatic/src/sequential-multi/RdPu.js';
import me, { scheme as scheme$n } from '../../../d3-scale-chromatic/src/sequential-multi/YlGnBu.js';
import he, { scheme as scheme$o } from '../../../d3-scale-chromatic/src/sequential-multi/YlGn.js';
import ge, { scheme as scheme$p } from '../../../d3-scale-chromatic/src/sequential-multi/YlOrBr.js';
import ye, { scheme as scheme$q } from '../../../d3-scale-chromatic/src/sequential-multi/YlOrRd.js';
import J, { scheme as scheme$9 } from '../../../d3-scale-chromatic/src/sequential-single/Blues.js';
import K, { scheme as scheme$a } from '../../../d3-scale-chromatic/src/sequential-single/Greens.js';
import L, { scheme as scheme$b } from '../../../d3-scale-chromatic/src/sequential-single/Greys.js';
import Q, { scheme as scheme$d } from '../../../d3-scale-chromatic/src/sequential-single/Purples.js';
import W, { scheme as scheme$e } from '../../../d3-scale-chromatic/src/sequential-single/Reds.js';
import N, { scheme as scheme$c } from '../../../d3-scale-chromatic/src/sequential-single/Oranges.js';
import ne from '../../../d3-scale-chromatic/src/sequential-multi/cividis.js';
import ie from '../../../d3-scale-chromatic/src/sequential-multi/cubehelix.js';
import be, { warm, cool } from '../../../d3-scale-chromatic/src/sequential-multi/rainbow.js';
import ve from '../../../d3-scale-chromatic/src/sequential-multi/sinebow.js';
import X from '../../../d3-scale-chromatic/src/sequential-multi/turbo.js';
import Y, { inferno, magma, plasma } from '../../../d3-scale-chromatic/src/sequential-multi/viridis.js';
import { useMemo } from 'react';
import get_1 from '../../../lodash/get.js';
import isPlainObject_1 from '../../../lodash/isPlainObject.js';
import { rgb } from '../../../d3-color/src/color.js';
import '../../../d3-color/src/lab.js';
import '../../../d3-color/src/cubehelix.js';
import '../../../prop-types/index.js';
import '../../../d3-array/dist/d3-array.js';
import ordinal from '../../../d3-scale/src/ordinal.js';
import '../../../d3-interpolate/dist/d3-interpolate.js';
import './../../../d3-scale/external_lib/d3-format/src/defaultLocale.js';
import './../../../d3-scale/external_lib/d3-format/src/formatSpecifier.js';
import '../../../d3-time/src/millisecond.js';
import '../../../d3-time/src/second.js';
import '../../../d3-time/src/minute.js';
import '../../../d3-time/src/hour.js';
import '../../../d3-time/src/day.js';
import '../../../d3-time/src/week.js';
import '../../../d3-time/src/month.js';
import '../../../d3-time/src/year.js';
import '../../../d3-time/src/utcMinute.js';
import '../../../d3-time/src/utcHour.js';
import '../../../d3-time/src/utcDay.js';
import '../../../d3-time/src/utcWeek.js';
import '../../../d3-time/src/utcMonth.js';
import '../../../d3-time/src/utcYear.js';
import '../../../d3-time-format/src/defaultLocale.js';
import '../../../d3-time-format/src/isoFormat.js';
import '../../../d3-time-format/src/isoParse.js';
import { exports as propTypesExports } from '../../../../_virtual/index2.js';
function qe() {
  return qe = Object.assign ? Object.assign.bind() : function (e) {
    for (var r = 1; r < arguments.length; r++) {
      var n = arguments[r];
      for (var t in n) Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t]);
    }
    return e;
  }, qe.apply(this, arguments);
}
function Se(e, r) {
  (null == r || r > e.length) && (r = e.length);
  for (var n = 0, t = new Array(r); n < r; n++) t[n] = e[n];
  return t;
}
function Re(e, r) {
  var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = function (e, r) {
    if (e) {
      if ("string" == typeof e) return Se(e, r);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Se(e, r) : void 0;
    }
  }(e)) || r && e && "number" == typeof e.length) {
    n && (e = n);
    var t = 0;
    return function () {
      return t >= e.length ? {
        done: !0
      } : {
        done: !1,
        value: e[t++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var Ce = {
    nivo: ["#e8c1a0", "#f47560", "#f1e15b", "#e8a838", "#61cdbb", "#97e3d5"],
    category10: e,
    accent: r,
    dark2: n,
    paired: t,
    pastel1: o,
    pastel2: i,
    set1: u,
    set2: a,
    set3: l
  },
  Ge = Object.keys(Ce),
  Ve = {
    brown_blueGreen: scheme,
    purpleRed_green: scheme$1,
    pink_yellowGreen: scheme$2,
    purple_orange: scheme$3,
    red_blue: scheme$4,
    red_grey: scheme$5,
    red_yellow_blue: scheme$6,
    red_yellow_green: scheme$7,
    spectral: scheme$8
  },
  Te = Object.keys(Ve),
  Pe = {
    brown_blueGreen: b,
    purpleRed_green: v,
    pink_yellowGreen: _,
    purple_orange: w,
    red_blue: O,
    red_grey: k,
    red_yellow_blue: j,
    red_yellow_green: z,
    spectral: A
  },
  Ue = {
    blues: scheme$9,
    greens: scheme$a,
    greys: scheme$b,
    oranges: scheme$c,
    purples: scheme$d,
    reds: scheme$e,
    blue_green: scheme$f,
    blue_purple: scheme$g,
    green_blue: scheme$h,
    orange_red: scheme$i,
    purple_blue_green: scheme$j,
    purple_blue: scheme$k,
    purple_red: scheme$l,
    red_purple: scheme$m,
    yellow_green_blue: scheme$n,
    yellow_green: scheme$o,
    yellow_orange_brown: scheme$p,
    yellow_orange_red: scheme$q
  },
  De = Object.keys(Ue),
  Me = {
    blues: J,
    greens: K,
    greys: L,
    oranges: N,
    purples: Q,
    reds: W,
    turbo: X,
    viridis: Y,
    inferno: inferno,
    magma: magma,
    plasma: plasma,
    cividis: ne,
    warm: warm,
    cool: cool,
    cubehelixDefault: ie,
    blue_green: ue,
    blue_purple: ae,
    green_blue: le,
    orange_red: se,
    purple_blue_green: ce,
    purple_blue: fe,
    purple_red: pe,
    red_purple: de,
    yellow_green_blue: me,
    yellow_green: he,
    yellow_orange_brown: ge,
    yellow_orange_red: ye
  },
  $e = qe({}, Ce, Ve, Ue),
  Be = Object.keys($e),
  Fe = function (e) {
    return Ge.includes(e);
  },
  He = function (e) {
    return Te.includes(e);
  },
  Je = function (e) {
    return De.includes(e);
  },
  Ke = {
    rainbow: be,
    sinebow: ve
  };
qe({}, Pe, Me, Ke);
var Qe = function (e, r) {
    if ("function" == typeof e) return e;
    if (isPlainObject_1(e)) {
      if (function (e) {
        return void 0 !== e.theme;
      }(e)) {
        if (void 0 === r) throw new Error("Unable to use color from theme as no theme was provided");
        var n = get_1(r, e.theme);
        if (void 0 === n) throw new Error("Color from theme is undefined at path: '" + e.theme + "'");
        return function () {
          return n;
        };
      }
      if (function (e) {
        return void 0 !== e.from;
      }(e)) {
        var t = function (r) {
          return get_1(r, e.from);
        };
        if (Array.isArray(e.modifiers)) {
          for (var o, i = [], u = function () {
              var e = o.value,
                r = e[0],
                n = e[1];
              if ("brighter" === r) i.push(function (e) {
                return e.brighter(n);
              });else if ("darker" === r) i.push(function (e) {
                return e.darker(n);
              });else {
                if ("opacity" !== r) throw new Error("Invalid color modifier: '" + r + "', must be one of: 'brighter', 'darker', 'opacity'");
                i.push(function (e) {
                  return e.opacity = n, e;
                });
              }
            }, a = Re(e.modifiers); !(o = a()).done;) u();
          return 0 === i.length ? t : function (e) {
            return i.reduce(function (e, r) {
              return r(e);
            }, rgb(t(e))).toString();
          };
        }
        return t;
      }
      throw new Error("Invalid color spec, you should either specify 'theme' or 'from' when using a config object");
    }
    return function () {
      return e;
    };
  },
  We = function (e, r) {
    return useMemo(function () {
      return Qe(e, r);
    }, [e, r]);
  },
  Xe = propTypesExports.oneOfType([propTypesExports.func, propTypesExports.arrayOf(propTypesExports.string), propTypesExports.shape({
    scheme: propTypesExports.oneOf(Be).isRequired,
    size: propTypesExports.number
  }), propTypesExports.shape({
    datum: propTypesExports.string.isRequired
  }), propTypesExports.string]);
propTypesExports.oneOfType([propTypesExports.string, propTypesExports.func, propTypesExports.shape({
  theme: propTypesExports.string.isRequired
}), propTypesExports.shape({
  from: propTypesExports.string.isRequired,
  modifiers: propTypesExports.arrayOf(propTypesExports.array)
})]);
var fr = function (e, r) {
    if ("function" == typeof e) return e;
    var n = "function" == typeof r ? r : function (e) {
      return get_1(e, r);
    };
    if (Array.isArray(e)) {
      var t = ordinal(e),
        o = function (e) {
          return t(n(e));
        };
      return o.scale = t, o;
    }
    if (isPlainObject_1(e)) {
      if (function (e) {
        return void 0 !== e.datum;
      }(e)) return function (r) {
        return get_1(r, e.datum);
      };
      if (function (e) {
        return void 0 !== e.scheme;
      }(e)) {
        if (Fe(e.scheme)) {
          var i = ordinal($e[e.scheme]),
            u = function (e) {
              return i(n(e));
            };
          return u.scale = i, u;
        }
        if (He(e.scheme)) {
          if (void 0 !== e.size && (e.size < 3 || e.size > 11)) throw new Error("Invalid size '" + e.size + "' for diverging color scheme '" + e.scheme + "', must be between 3~11");
          var a = ordinal($e[e.scheme][e.size || 11]),
            l = function (e) {
              return a(n(e));
            };
          return l.scale = a, l;
        }
        if (Je(e.scheme)) {
          if (void 0 !== e.size && (e.size < 3 || e.size > 9)) throw new Error("Invalid size '" + e.size + "' for sequential color scheme '" + e.scheme + "', must be between 3~9");
          var s = ordinal($e[e.scheme][e.size || 9]),
            c = function (e) {
              return s(n(e));
            };
          return c.scale = s, c;
        }
      }
      throw new Error("Invalid colors, when using an object, you should either pass a 'datum' or a 'scheme' property");
    }
    return function () {
      return e;
    };
  },
  pr = function (e, r) {
    return useMemo(function () {
      return fr(e, r);
    }, [e, r]);
  };
export { Ge as categoricalColorSchemeIds, Ce as categoricalColorSchemes, Be as colorSchemeIds, $e as colorSchemes, Ke as cyclicalColorInterpolators, Pe as divergingColorInterpolators, Te as divergingColorSchemeIds, Ve as divergingColorSchemes, Qe as getInheritedColorGenerator, fr as getOrdinalColorScale, Fe as isCategoricalColorScheme, He as isDivergingColorScheme, Je as isSequentialColorScheme, Xe as ordinalColorsPropType, Me as sequentialColorInterpolators, De as sequentialColorSchemeIds, Ue as sequentialColorSchemes, We as useInheritedColor, pr as useOrdinalColorScale };
//# sourceMappingURL=nivo-colors.es.js.map
